import { useMediaQuery } from "@certn/cascadia-react/hooks/useMediaQuery";
import { breakpoints } from "@certn/cascadia-tokens";

export function useNavbar() {
  const canToggle = useMediaQuery(
    `(max-width: ${breakpoints["breakpoint-lg"].maxWidth.toString()}px)`
  );

  return {
    canToggle,
  };
}
